import React, { Component } from 'react';
import {Link, withRouter} from 'react-router-dom'

class Footer extends Component {

  render() {
    return (
      <footer className="py-5 bg-dark" style={{marginTop: '100px'}}>
        <div className="container">
            {(new Date().getFullYear() !== 2017)
                ?
                <p className="m-0 text-center text-white">
                  <Link to={'/about'}>About</Link>
                  &nbsp;|&nbsp;
                  <Link to={'/contact'}>Contact</Link>
                  &nbsp;|&nbsp;
                  Copyright &copy;2017-{new Date().getFullYear()} Zoetrove</p>
                :
                <p className="m-0 text-center text-white">
                  <Link to={'/about'}>About</Link>
                  &nbsp;|&nbsp;
                  <Link to={'/contact'}>Contact</Link>
                  &nbsp;|&nbsp;
                  Copyright &copy;{new Date().getFullYear()} CWH3 Holdings LLC</p>
            }
        </div>
      </footer>
    );
  }
}

export default withRouter(Footer);




// WEBPACK FOOTER //
// ./src/Components/Footer.jsx